export const TAG_TYPES = [
  'Products',
  'Report',
  'BlockedHosts',
  'GisImport',
  'OptimizedNames',
  'Projects',
  'News',
  'Article',
  'ListNotifications',
  'DetailNotification',
  'NotificationsForUser',
  'SupportChat',
  'SupportRequestsUser',
  'SupportRequest',
  'FAQ',
  'GloballyBlockedSources',
  'BlockedSourcesOnProjects',
  'UsersStorageScreenshots',
  'OrganizationsStorageScreenshots',
  'UserGuideStatus',
  'UserGuide',
  'UserRequests',
  'Handbook',
  'Handbooks',
  'StandardSizeReport',
  'StandardSize',
  'SizeQueue',
  'Organizations',
  'Organization',
  'OrganizaionAccesses',
  'Users',
  'Suppliers',
  'SuppliersCategories',
  'Session',
  'Chats',
  'ChatMessages',
  'Categories',
  'AdminUsers',
  'AdminOrganizations',
  'SupplierDownload',
  'StorageList',
  'StorageCleanup',
  'BlockedDomains',
  'ServiceMessage',
  'Notifications',
  'PriceErrorRequest',
  'RequestLimit',
  'AnalyticsExport',
  'CatalogEntries',
  'CatalogEntryAnalogs',
  'CatalogFilters',
] as const;

export type TagType = (typeof TAG_TYPES)[number];